export default "__VITE_PUBLIC_ASSET__84bc600a__"